import { render, staticRenderFns } from "./ParticipationRuleSection.vue?vue&type=template&id=4beccad2&"
import script from "./ParticipationRuleSection.vue?vue&type=script&lang=js&"
export * from "./ParticipationRuleSection.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationRuleSection.vue?vue&type=style&index=0&id=4beccad2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports